import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logom.png";

import "./RecuperarPassword.css";
import { recuperarpass } from "../../../service/api";
import { toast } from "react-toastify";
import SpinnerModal from "../../../componentes/spiner/SpinnerModal";

export default function RecuperarPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const emailOk = useMemo(() => {
    if (!email) return true;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }, [email]);

  const onSubmit = async (e) => {
    e.preventDefault();


    if (!email.trim() || !emailOk) {
      this.setState({ errorMsg: "Completa correo y contraseña." });
      return;
    }
    if (!emailOk) {
      this.setState({ errorMsg: "Correo inválido." });
      return;
    }

    try {


      setLoading(true);
      await new Promise((r) => setTimeout(r, 900));


      var resp = await recuperarpass(email.trim())

      if (resp.code == 0) {
        setSent(true);
      }
      else {
        toast.info(resp.message);
        setSent(true);
      }



    } finally {
      setLoading(false);
    }
  };



  return (
    <div className="mm-shell">

      {(loading == true) ? (
        <SpinnerModal tipo="full" show={loading} />
      ) : null}
      <main className="mm-center">
        <section className="mm-card" aria-label="Recuperar contraseña">
          <div className="mm-logoImgWrapr">
            <img className="mm-logoImgr" src={logo} alt="Morena Mia Beauty" />
          </div>

          <h1 className="mm-title">Recuperar contraseña</h1>

          {!sent ? (
            <>
              <p className="mm-desc">
                Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
              </p>

              <form className="mm-form" onSubmit={onSubmit}>
                <label className="mm-label">
                  <span>Correo electrónico</span>
                  <div className={`mm-inputWrap ${!emailOk ? "mm-error" : ""}`}>
                    <span className="mm-icon" aria-hidden="true">@</span>
                    <input
                      className="mm-input"
                      type="email"
                      inputMode="email"
                      autoComplete="email"
                      placeholder="correo@correo.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      aria-invalid={!emailOk}
                    />
                  </div>
                  {!emailOk && <small className="mm-help">Escribe un correo válido.</small>}
                </label>

                <button className="mm-btn" type="submit" disabled={loading || !email.trim() || !emailOk}>
                  {loading ? "ENVIANDO..." : "ENVIAR ENLACE"}
                </button>

                <div className="mm-actions">
                  <Link className="mm-link" to="/">
                    ← Volver al login
                  </Link>
                </div>

                <p className="mm-footnote">
                  © {new Date().getFullYear()} Morena Mia Beauty. Todos los derechos reservados.
                </p>
              </form>
            </>
          ) : (
            <div className="mm-success">
              <h2 className="mm-successTitle">Revisa tu correo</h2>
              <p className="mm-successText">
                Te llegará un enlace para restablecer tu contraseña.
              </p>

              <Link className="mm-btn mm-btnAlt" to="/">
                IR AL LOGIN
              </Link>

              <p className="mm-footnote">
                © {new Date().getFullYear()} Morena Mia Beauty. Todos los derechos reservados.
              </p>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}
